export function normalizeName (value) {
  return value
    .replace(/[^a-zA-Z\s´ÁÉÍÓÚáéíóúñÑ˜]+/g, '')
    .replace(/(´.{1,1})+/g, '')
    .replace(/(˜.{1,1})+/g, '');
}

export function normalizePhone (value) {
  return value.replace(/[^\d]/g, '').substring(0, 10);
}